import styles from './lead-card.module.scss';
import Button from '../Button/Button';
import { useEffect, useState } from 'react';
import {  } from '../../Services/api.service';
import TextArea from '../TextArea/TextArea';

const LeadCard = (props) => {
    const [isMobile, ] = useState(window.innerWidth <= 768);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");
    const [notes, setNotes] = useState("");

    useEffect(() => {
        setStatus(props.status);
        setNotes(props.notes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleButtonClick = async (type) => {
        setLoading(true);
        // const data = {
        //     "status": type
        // };
    
        try {
            // await updateLeadStatus(props.id, data);
            // You can add any follow-up actions here after the status is updated, like notifying the user or updating state.
        } catch (error) {
            console.error("Error updating lead status:", error);
            // Handle the error (e.g., show an error message)
        } finally {
            setStatus(type);
            setLoading(false);
        }
    };

    const handleNoteUpdate = async () => {
        setLoading(true);
        // const data = {
        //     "notes": notes
        // };

        try {
            // await updateLeadNote(props.id, data);
            // You can add any follow-up actions here after the status is updated, like notifying the user or updating state.
        } catch (error) {
            console.error("Error updating lead status:", error);
            // Handle the error (e.g., show an error message)
        } finally {
            setLoading(false);
        }
    }

    const renderGDriveLink = (gDriveLink) => {
        if (!gDriveLink) return "gDriveLink"; // Display text if blank
        if (gDriveLink === "N/A") return null;
        if (gDriveLink === "Syncing") return "syncing docs";
        if (!gDriveLink.startsWith("http")) return gDriveLink; // Display as plain text
    
        return (
            <a href={gDriveLink} target='_blank' rel='noreferrer'>
                view drawings
            </a>
        );
    };    

    return (
        <div className={styles.container}>
            {loading ?
                <h3>Loading..</h3>
            :
                <>
                    <div className={styles.titleContainer}>
                        <p><b>{props.title}</b></p>
                    </div>

                    <div className={styles.middleContainer}>
                        <p>
                            {props.bidDate}
                            <br />
                            {props.address.slice(0, isMobile ? 34 : 50)}
                            {props.address.length > (isMobile ? 34 : 50) ? "..." : ""}
                            <br />
                            {formatCurrency(props.projectValue)}
                        </p>
                        <p className={styles.rightAlign}>
                            {props.platformLink !== "N/A" ?
                                <a
                                    href={props.platformLink}
                                    target='_blank'
                                    rel='noreferrer'>
                                        {extractPlatform(props.platformLink)}
                                </a>
                            :
                                null
                            }
                            <br/>
                            <a
                                href={props.url}
                                target='_blank'
                                rel='noreferrer'>
                                    constructconnect
                            </a><br/>
                            {renderGDriveLink(props.gDriveLink)}
                        </p>
                    </div>

                    <div className={styles.buttonContainer}>
                        <Button
                            selected={status === "Review" ? true : false}
                            buttonText = "Review"
                            onClick={() => handleButtonClick("Review")}
                        />
                        <Button
                            selected={status === "Bid" ? true : false}
                            buttonText = "Bid"
                            onClick={() => handleButtonClick("Bid")}
                        />
                        <Button
                            selected={status === "Sub-Bid" ? true : false}
                            buttonText = "Sub-Bid"
                            onClick={() => handleButtonClick("Sub-Bid")}
                        />
                        <Button
                            selected={status === "No-Bid" ? true : false}
                            buttonText = "No-Bid"
                            onClick={() => handleButtonClick("No-Bid")}
                        />
                    </div>
                    
                    <div className={styles.descriptionContainer}>
                        <p>{props.description}</p>
                    </div>

                    <div className={styles.textAreaContainer}>
                        <TextArea
                            value={notes}
                            label="Notes"
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    </div>

                    <div className={styles.buttonActionWrapper}>
                        <Button
                            buttonText = "View lead"
                            onClick={props.onClick}
                        />
                        <Button
                            buttonText = "Update note"
                            onClick={() => handleNoteUpdate()}
                        />
                    </div>
                </>
            }

        </div>
    );
};

export default LeadCard;

const extractPlatform = (domain) => {
    const regex = /(?:https?:\/\/)?(?:[^.]+\.)?([^.]+)\.(?:com|ca)(?:\/|$)/i;
    const match = domain.match(regex);
  
    if (match) {
        return match[1]; // Return the second-level domain
    }
  
    return null; // If no match is found
};

export const formatCurrency = (amount) => {
    if (isNaN(amount)) {
        throw new Error("Invalid number");
    }

    if (!amount) {
        return ''
    }

    return `$ ${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}